export const GET_ALL_SUPPLIES = 'GET_ALL_SUPPLIES';
export const REMOVE_SUPPLY = 'REMOVE_SUPPLY';
export const RESET_SUPPLIES_LIST = 'RESET_SUPPLIES_LIST';
export const ADD_SUPPLY_TO_LIST = 'ADD_SUPPLY_TO_LIST';